var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.136 3.907c0 .83-.505 1.444-1.372 1.444-.722 0-1.264-.614-1.264-1.444 0-.794.578-1.444 1.336-1.444.795 0 1.3.65 1.3 1.444m-1.998 43.398V14.108h1.36v33.197zm46.62-23.653c0 16.737-9.291 24.345-19.461 24.345-10.39 0-18.803-8.23-18.803-23.652C19.494 8.508 28.201 0 39.028 0 49.637 0 57.758 8.368 57.758 23.652m-36.885.346c0 12.69 6.15 22.549 17.488 22.549 11.416 0 17.964-10.162 17.964-22.693 0-11.62-5.246-22.226-17.218-22.226s-18.234 9.985-18.234 22.37m41.88 19.71c2.282 1.522 6.222 2.991 9.611 2.991 6.432 0 12.152-4.5 12.152-11.123 0-6.146-3.81-9.352-10.28-12.107-5.79-2.466-10.996-5.142-10.996-11.712C63.24 4.91 68.634.068 75.965.068c3.942 0 6.916 1.107 8.3 2.075l-.55 1.194c-1.176-.83-4.354-1.886-7.81-1.886-7.748 0-11.123 5.854-11.123 10.164 0 5.953 4.614 7.943 10.562 10.779 6.915 3.388 10.58 6.376 10.58 12.877 0 6.985-4.979 12.655-13.831 12.655-3.666 0-7.884-1.244-9.96-2.835z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.5 0h75.424v48H10.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOs);
export default __webpack_public_path__ + "static/media/iOS.a1d9ea807382d4b5860b8421776ffacd.svg";
export { ForwardRef as ReactComponent };